module.exports = __webpack_public_path__ + "static/media/bird_making_home_02.c43966ce.gif";